module.exports = __webpack_public_path__ + "static/media/mko.b8d077d1.png";